import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
import DataTable from "utils/Tables/DataTable";
import MDInput from "components/MDInput";
import { CircularProgress, Stack } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import {
  FETCH_COMPANY_LIST,
  FETCH_SUBSCRIPTION_PLANS,
  FETCH_INDUSTRIES_LIST,
  ADMIN_DELETE_COMPANY,
  USER_ROLES,
} from "lib/constants";
import { displayDate } from "utils/Date";
import { useSelector } from "react-redux";
import CreateNewCompanyForm from "pages/CreateNewCompany/CreateNewCompanyForm";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { getAPICall, deleteAPICall } from "../../lib/callApi";

function CompanyList() {
  const user = useSelector((state) => state.loginUser.loginUserState);
  // const [open, setOpen] = useState(false);
  // const [activeStatus, setActiveStatus] = useState(false);
  // const [statusValue, setStatusValue] = useState("");
  // const [planTypeValue, setPlanTypeValue] = useState("");

  // const [selectedCompany, setSelectedCompany] = useState({});
  // const [subscriptions, setSubscriptions] = useState([]);
  // const [statusError, setStatusError] = useState(false);
  // const [typeError, setTypeError] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [editCompanyDetailsModal, setEditCompanyDetailsModal] = useState(false);
  const [deleteCompanyDetailsModal, setDeleteCompanyDetailsModal] = useState(false);
  const [deleteCompanyId, setDeleteCompanyId] = useState(null);
  const [editCompanyDetailData, setEditCompanyDetailData] = useState(null);
  const [planTypeOptions, setPlanTypeOptions] = useState([]);
  const [getCompanyName, setGetCompanyName] = useState(null);
  const [industriesList, setIndustriesList] = useState([]);
  const [companyRolesList, setCompanyRolesList] = useState([]);
  // const handleClose = () => {
  //   setOpen(false);
  //   setStatusValue("");
  //   setPlanTypeValue("");
  // };

  const navigate = useNavigate();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: window.innerWidth < 400 ? "100%" : 600,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    "& .MuiFormHelperText-root": { color: "#d32f2f" },
  };

  // const fetchSubscriptions = async () => {
  //   const result = await getAPICall(SUBSCRIPTION, true);

  //   if (result?.data?.success) {
  //     const mainData = [];
  //     result?.data?.data?.forEach((item) => {
  //       mainData.push({
  //         label: item.name,
  //         value: item.id,
  //       });
  //     });
  //     setSubscriptions([...mainData]);
  //   }
  // };

  useEffect(() => {
    const userData = localStorage.getItem("user");

    if (!userData) {
      navigate("/sign-in");
    }

    // fetchSubscriptions();
  }, []);

  const [formattedData, setFormattedData] = useState([]);
  const [companies, setCompanies] = useState({
    columns: [
      {
        header: "Company Name",
        accessorKey: "companyName",
        wordBreak: "break-word",
        minWidth: "150px",
      },
      {
        header: "Name",
        accessorKey: "name",
        wordBreak: "break-word",
        minWidth: "120px",
      },
      {
        header: "Email",
        accessorKey: "email",
        wordBreak: "break-word",
        minWidth: "200px",
      },
      {
        header: "Join Date",
        accessorKey: "joinDate",
        wordBreak: "break-word",
        minWidth: "120px",
        sortType: (a, b) => new Date(b.values.joinDate) - new Date(a.values.joinDate),
      },
      {
        header: "Plan Type",
        accessorKey: "planType",
        wordBreak: "break-word",
        minWidth: "100px",
        id: "planType",
      },
      {
        header: "Seat Count",
        accessorKey: "seatCount",
        wordBreak: "break-word",
        minWidth: "100px",
        id: "seatCount",
      },
      {
        header: "Salesbricks ID",
        accessorKey: "salesBricksId",
        wordBreak: "break-word",
        minWidth: "120px",
      },
      {
        header: "Subscription End Date",
        accessorKey: "subscriptionEndDate",
        width: "5%",
        wordBreak: "break-word",
        id: "subscriptionEndDate",
        minWidth: "120px",
        sortType: (a, b) =>
          new Date(b.values.subscriptionEndDate) - new Date(a.values.subscriptionEndDate),
      },
      {
        header: "",
        accessorKey: "actions",
        width: "7%",
        wordBreak: "break-word",
        disableSortBy: true,
      },
    ],
    rows: [],
  });

  const handleOpenEditCompanyModal = (data) => {
    setEditCompanyDetailData(data);
    setEditCompanyDetailsModal(true);
  };

  const handleOpenDeleteCompanyModal = (data) => {
    setDeleteCompanyId(data.id);
    setGetCompanyName(data.name);
    setDeleteCompanyDetailsModal(true);
  };

  const fetchCompanies = async () => {
    setIsLoading(true);
    try {
      const result = await getAPICall(FETCH_COMPANY_LIST, true);

      if (result?.data?.success) {
        const dataFormat = [];

        result?.data?.data?.forEach((data) => {
          // setActiveStatus(data.status === "inactive");
          dataFormat.push({
            companyName: data.name,
            name: data.Users?.[0]?.name,
            email: data.email,
            joinDate: displayDate(data.createdAt, user.dateFormat),
            planType: data.subscriptionDetails?.planName,
            seatCount: data.subscriptionDetails.seatCount,
            salesBricksId: data.externalSubscriptionId,
            subscriptionEndDate: data?.subscriptionDetails?.endDate
              ? displayDate(data.subscriptionDetails.endDate, user.dateFormat)
              : "",
            companyRoles: data.user_company_roles,
            adminCompanyRole: data.UserCompaniesLinks?.[0]?.UserCompanyRole?.role_name,
            actions: (
              <MDBox sx={{ fontSize: "20px", display: "flex" }}>
                <EditIcon
                  style={{ marginRight: "15px", cursor: "pointer" }}
                  onClick={() => handleOpenEditCompanyModal(data)}
                />
                <DeleteIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpenDeleteCompanyModal(data)}
                />
              </MDBox>
            ),
          });
        });

        const duplicateFormats = { ...companies };
        duplicateFormats.rows = dataFormat;

        setFormattedData(dataFormat);
        setCompanies({ ...duplicateFormats });
      } else if (result?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: result?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
    } catch (error) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
    setIsLoading(false);
  };

  function handleSearch(searchTerm) {
    const searchRegex = new RegExp(searchTerm, "i");
    const searchArray = formattedData.filter(
      (item) =>
        searchRegex.test(item?.companyName) ||
        searchRegex.test(item?.name) ||
        searchRegex.test(item?.email) ||
        searchRegex.test(item?.planType) ||
        searchRegex.test(item?.seatCount?.toString()) ||
        searchRegex.test(item?.salesBricksId?.toString())
    );

    const duplicateFormats = { ...companies };
    duplicateFormats.rows = searchArray;
    setCompanies({ ...duplicateFormats });
  }

  const fetchPlans = async () => {
    const result = await getAPICall(FETCH_SUBSCRIPTION_PLANS, true);
    if (result?.data?.success) {
      setPlanTypeOptions((result.data.data || []).filter((data) => data?.id));
    }
  };

  const fetchIndustries = async () => {
    const result = await getAPICall(FETCH_INDUSTRIES_LIST, true);
    if (result?.data?.success) {
      setIndustriesList(result.data?.data?.industries || []);
    }
  };

  const fetchCompanyRoles = async () => {
    const result = await getAPICall(USER_ROLES, true);
    if (result?.data?.success) {
      setCompanyRolesList(result?.data?.data || []);
    }
  };

  useEffect(() => {
    fetchCompanies();
    fetchPlans();
    fetchIndustries();
    fetchCompanyRoles();
  }, []);

  const handleCloseEditCompanyModal = (shouldRefreshData = false) => {
    if (shouldRefreshData === true) fetchCompanies();
    setEditCompanyDetailData(null);
    setEditCompanyDetailsModal(false);
  };

  const handleCloseDeleteCompanyModal = () => {
    setDeleteCompanyId(null);
    setGetCompanyName(null);
    setDeleteCompanyDetailsModal(false);
  };

  // eslint-disable-next-line consistent-return
  // const callCreateComapny = async () => {
  //   try {
  //     if (!planTypeValue) {
  //       return setTypeError(true);
  //     }
  //     if (!statusValue) {
  //       return setStatusError(true);
  //     }

  //     setIsLoading(true);
  //     const dataToPass = {
  //       companyId: selectedCompany.id,
  //       subscriptionId: selectedCompany.subscriptionId,
  //       email: selectedCompany.email,
  //       name: selectedCompany.name,
  //       firstName: selectedCompany.ownerFirstName,
  //       lastName: selectedCompany.ownerLastName,
  //       status: activeStatus === true ? "active" : "inactive",
  //       contactNo: selectedCompany.contactNo,
  //       timezone: momentTz.tz.guess(),
  //     };

  //     const result = await ADD_COMPANY_BY_ADMIN, true, dataToPass);

  //     if (result?.data?.success) {
  //       setIsLoading(false);
  //       handleClose();
  //       enqueueSnackbar(
  //         JSON.stringify({
  //           icon: "info",
  //           title: "Information",
  //           text: "Company details is added successfully!",
  //         }),
  //         {
  //           variant: "custom",
  //         }
  //       );
  //       fetchCompanies();
  //     } else {
  //       setIsLoading(false);
  //       setOpen(false);
  //       enqueueSnackbar(
  //         JSON.stringify({
  //           icon: "error",
  //           title: "Error",
  //           text: "Something went wrong!",
  //         }),
  //         {
  //           variant: "custom",
  //         }
  //       );
  //     }
  //   } catch (error) {
  //     enqueueSnackbar(
  //       JSON.stringify({
  //         icon: "info",
  //         title: "Information",
  //         text: "Something went wrong!",
  //       }),
  //       {
  //         variant: "custom",
  //       }
  //     );
  //   }
  // };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Company listing in data table */}
      <Card>
        <MDBox p={3} lineHeight={1}>
          <MDTypography variant="h5" fontWeight="medium">
            Registered Company List
          </MDTypography>
          <MDBox mt={3} pr={3}>
            <MDInput
              label="Search"
              disabled={isLoading}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </MDBox>
        </MDBox>
        {isLoading ? (
          <Stack alignItems="center">
            <CircularProgress
              sx={{
                position: "fixed",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}
              color="info"
              size="10vh"
            />
          </Stack>
        ) : (
          ""
        )}
        <DataTable table={companies} />
      </Card>

      {/* {editCompanyDetailsModal && ( */}
      <Modal
        open={editCompanyDetailsModal}
        onClose={handleCloseEditCompanyModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox sx={style} noValidate>
          <MDTypography id="modal-modal-title" variant="h5" component="h2">
            Edit company
          </MDTypography>
          <CreateNewCompanyForm
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            handleModalClose={handleCloseEditCompanyModal}
            editCompanyDetailData={editCompanyDetailData}
            planTypeOptions={planTypeOptions}
            industriesList={industriesList}
            companyRolesList={companyRolesList}
          />
        </MDBox>
      </Modal>

      <Modal
        open={deleteCompanyDetailsModal}
        onClose={handleCloseDeleteCompanyModal}
        aria-labelledby="delete-company-title"
      >
        <MDBox sx={style} noValidate>
          <MDTypography id="delete-company-title" variant="h5" component="h2">
            Are you sure you want to delete the company {getCompanyName}?
          </MDTypography>
          <MDBox>
            <MDButton onClick={handleCloseDeleteCompanyModal} disabled={isLoading}>
              Cancel
            </MDButton>
            <MDButton
              disabled={isLoading}
              onClick={async () => {
                try {
                  setIsLoading(true);
                  const result = await deleteAPICall(
                    `${ADMIN_DELETE_COMPANY}${deleteCompanyId}`,
                    true
                  );
                  if (result.data.success) {
                    enqueueSnackbar(
                      JSON.stringify({
                        icon: "success",
                        title: "Success",
                        text: result.data.message,
                      }),
                      {
                        variant: "custom",
                      }
                    );
                    fetchCompanies();
                  } else {
                    enqueueSnackbar(
                      JSON.stringify({
                        icon: "error",
                        title: "Error",
                        text: result.data.message,
                      }),
                      {
                        variant: "custom",
                      }
                    );
                  }
                } catch (error) {
                  enqueueSnackbar(
                    JSON.stringify({
                      icon: "error",
                      title: "Error",
                      text: "Something went wrong!",
                    }),
                    {
                      variant: "custom",
                    }
                  );
                } finally {
                  handleCloseDeleteCompanyModal();
                  setIsLoading(false);
                }
              }}
            >
              Confirm
            </MDButton>
          </MDBox>
        </MDBox>
      </Modal>
      {/* )} */}

      {/* Old method */}
      {/* Add/create Company Modal */}
      {/* {open && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <MDBox sx={style} role="form" component="form" noValidate>
            <MDTypography id="modal-modal-title" variant="h5" component="h2">
              Add company
            </MDTypography>
            <MDBox>
              <MDBox mt={2}>
                <MDInput
                  label="Company Name"
                  fullWidth
                  name="name"
                  defaultValue={selectedCompany.name}
                  disabled
                />
              </MDBox>

              <MDBox mt={2}>
                <MDInput
                  type="text"
                  label="Company Email"
                  fullWidth
                  name="email"
                  defaultValue={selectedCompany.email}
                  disabled
                />
              </MDBox>
              <MDBox mt={2}>
                <MDInput
                  type="text"
                  label="Size"
                  fullWidth
                  name="size"
                  defaultValue={selectedCompany.size}
                  disabled
                />
              </MDBox>
              <MDBox mt={2}>
                <MDInput
                  type="text"
                  label="Company Contact Number"
                  fullWidth
                  name="contactNo"
                  defaultValue={selectedCompany.contactNo}
                  disabled
                />
              </MDBox>
              <MDBox mt={2}>
                <Autocomplete
                  fullWidth
                  disablePortal
                  id="combo-box-demo"
                  options={subscriptions}
                  renderInput={(params) => (
                    <TextField {...params} label="Subscription Plans" error={typeError} />
                  )}
                  onChange={(event, value) => {
                    setSelectedCompany({ ...selectedCompany, subscriptionId: value.value });
                    setPlanTypeValue(value.label);
                    setTypeError(false);
                  }}
                />
              </MDBox>
              <MDBox mt={2}>
                <Autocomplete
                  fullWidth
                  disablePortal
                  id="combo-box-demo1"
                  options={[
                    { label: "Active", value: true },
                    { label: "Inactive", value: false },
                  ]}
                  renderInput={(params) => (
                    <TextField {...params} label="Subscription Status" error={statusError} />
                  )}
                  onChange={(event, value) => {
                    setActiveStatus(value.value);
                    setStatusValue(value.label.toLowerCase());
                    setStatusError(false);
                  }}
                />
              </MDBox>
              <MDBox mt={1} sx={{ display: "flex", justifyContent: "end" }}>
                <MDButton
                  variant="gradient"
                  color="secondary"
                  size="small"
                  onClick={handleClose}
                  style={{ marginRight: "10px" }}
                >
                  Cancel
                </MDButton>
                {isLoading ? (
                  <MDButton variant="gradient" color="newColor" size="small">
                    Loading...
                  </MDButton>
                ) : (
                  <MDButton
                    variant="gradient"
                    color="newColor"
                    size="small"
                    onClick={() => callCreateComapny()}
                  >
                    Create
                  </MDButton>
                )}
              </MDBox>
            </MDBox>
          </MDBox>
        </Modal>
      )} */}
    </DashboardLayout>
  );
}

export default CompanyList;
